import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Modal, Textinput, Flex, Typo, theme } from '../../../ui';

const NativeInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${theme.colors.NEU_200};
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: ${theme.colors.NEU_PRIMARY};
  background: ${theme.colors.NEU_0};

  &:focus {
    outline: none;
    border-color: ${theme.colors.PRIMARY};
  }
`;

const FieldLabel = styled(Typo.SmallText)`
  color: ${theme.colors.NEU_600};
  font-weight: 500;
  margin-bottom: 4px;
`;

const AddAssignmentModal = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [dueDate, setDueDate] = useState('');

  const handleAccept = async () => {
    await onSubmit({
      name,
      description,
      dueDate: dueDate ? new Date(dueDate).toISOString() : null,
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('classroom.addAssignment', 'Add Assignment')}
      width='480px'
      showActions
      onAccept={handleAccept}
      acceptLabel={t('globals.add', 'Add')}
      acceptIsDisabled={!name.trim()}
    >
      <Flex direction='column' gap='16'>
        <Textinput
          label={t('classroom.assignmentName', 'Name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='e.g. Week 7 — Assignment'
        />
        <Textinput
          label={t('classroom.description', 'Description')}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          isMultiline
          minRows={3}
          placeholder='Describe the assignment...'
        />
        <Flex direction='column' gap='4'>
          <FieldLabel>{t('classroom.dueDate', 'Due Date')}</FieldLabel>
          <NativeInput
            type='datetime-local'
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
          />
        </Flex>
      </Flex>
    </Modal>
  );
};

export default AddAssignmentModal;
